// TestReusableTable.js
import React from 'react';

const TestReusableTable = ({ columns, data, filters, onFilterChange }) => {
  // Filter the data based on the filter criteria passed
  const filteredData = data.filter((item) => {
    return columns.every((column) => {
      const value = item[column.accessor];
      if (!filters[column.accessor]) return true; // No filter applied for this column
      return value.toString().toLowerCase().includes(filters[column.accessor].toLowerCase());
    });
  });

  return (
    <div>
      {/* Filters Row */}
      <div className="filters">
        {columns.map((column) => (
          <div key={column.accessor} className="filter">
            <input
              type="text"
              placeholder={`Filter by ${column.Header}`}
              value={filters[column.accessor] || ''}
              onChange={(e) => onFilterChange(column.accessor, e.target.value)}
            />
          </div>
        ))}
      </div>

      {/* Table */}
      <table border="1" cellPadding="10" className="table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.accessor}>{column.Header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan={columns.length}>No Data Available</td>
            </tr>
          ) : (
            filteredData.map((row, index) => (
              <tr key={index}>
                {columns.map((column) => (
                  <td key={column.accessor}>{row[column.accessor]}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TestReusableTable;
